import fromDesigner from './formDesigner.vue'
import fromGenerator from './formGenerator.vue'
import elementGenerator from "./elementGenerator";

export default {
    fromDesigner,
    fromGenerator,
    elementGenerator
};
